import { Box, Typography } from '@mui/material';
import InlineEdit from '~/components/InlineEdit';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import useRoi from '~/hooks/structure-set/useRoi';
import RoiColor from './RoiColor';

interface StructureLabelProps {
    roi: RoiReadModel;
    isEditing?: boolean;
    onNameChange?: (value: string) => void;
    onEditCancel?: () => void;
    onStartEdit?: () => void;
    validate?: (name: string) => string | null;
}

export default function StructureLabel({
    roi,
    isEditing = false,
    onNameChange,
    onEditCancel,
    onStartEdit,
    validate,
}: StructureLabelProps) {
    const isMarker = roi.isPointRoi;

    const { isRoiEmpty } = useRoi(roi);
    const isEmptyVolume = isRoiEmpty();
    return (
        <Box
            display="grid"
            gridTemplateColumns={'auto 1fr'}
            alignItems="center"
            gap={1}
        >
            <RoiColor
                color={roi.color}
                size={10}
                isEmptyVolume={isEmptyVolume}
                isMarker={isMarker}
            />
            {isEditing && onNameChange && onEditCancel ? (
                <InlineEdit
                    value={roi.name}
                    onSubmit={onNameChange}
                    onCancel={onEditCancel}
                    validate={validate}
                    fontSize={13}
                    fontWeight={500}
                />
            ) : (
                <Typography
                    variant="body1"
                    fontSize={13}
                    fontWeight={500}
                    title={roi.name}
                    onDoubleClick={onStartEdit}
                    sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.2,
                        cursor: onStartEdit ? 'pointer' : undefined,
                    }}
                >
                    {roi.name}
                </Typography>
            )}
        </Box>
    );
}
